export const underscoresToSpaces = (text) => {
  return text.replace(/_/g, ' ')
}

export const normalizeCapitalization = (string, uppercase) => (
  uppercase ? string.charAt(0) + string.toLowerCase().slice(1) : string.charAt(0).toUpperCase() + string.slice(1)
)
